export const LAYOUT_SET_PREVIOUS_URL_REQUEST =
  'LAYOUT_SET_PREVIOUS_URL_REQUEST';
